// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"413":"dafbf89e","751":"55249864","906":"55249864"}[chunkId] + ".css";
};